module.exports = __webpack_public_path__ + "media/auto_history/wycofanie-31b68005.svg";